import { SeasonalityMode, TrendMode } from "@domain/forecast/models/ForecastParameters";
import { ListSubheader, Menu, MenuItem, Select, SelectChangeEvent, Slider, Stack, Typography } from "@mui/material";

export interface ForecastSettingsMenuProps {
    onModeChange?: (mode: SeasonalityMode) => void;
    defaultMode?: SeasonalityMode;

    onInfluenceChange?: (influence: number) => void;
    defaultInfluence?: number;

    onTrendModeChange?: (mode: TrendMode) => void;
    defaultTrendMode?: TrendMode;

    anchorEl: null | HTMLElement;
    onClose: () => void;

    title?: string;
}

export const ForecastSettingsMenu: React.FC<ForecastSettingsMenuProps> = ({ onModeChange, onInfluenceChange, defaultMode, defaultInfluence, onTrendModeChange, defaultTrendMode, anchorEl, onClose, title }) => {

    const handleModeChange = (event: SelectChangeEvent<string>) => {
        onModeChange?.(event.target.value as SeasonalityMode);
    };

    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        onInfluenceChange?.(newValue as number);
    };

    const handleTrendModeChange = (event: SelectChangeEvent<string>) => {
        onTrendModeChange?.(event.target.value as TrendMode);
    };

    return (

        <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} onClose={onClose}>

            <ListSubheader>
                {title}
            </ListSubheader>


            {onModeChange && (

                <MenuItem>

                    <Stack direction="row" spacing={4} justifyContent="space-between" alignItems="center">

                        <Typography variant="body2" color="text.secondary"> Mode </Typography>

                        <Select defaultValue={defaultMode} onChange={handleModeChange}>
                            <MenuItem value={SeasonalityMode.ADDITIVE}>Additive</MenuItem>
                            <MenuItem value={SeasonalityMode.MULTIPLICATIVE}>Multiplicative</MenuItem>
                        </Select>

                    </Stack>
                </MenuItem>

            )}

            {onTrendModeChange && (

                <MenuItem>

                    <Stack direction="row" spacing={4} justifyContent="space-between" alignItems="center">

                        <Typography variant="body2" color="text.secondary"> Mode </Typography>

                        <Select defaultValue={defaultTrendMode} onChange={handleTrendModeChange}>
                            <MenuItem value={TrendMode.LINEAR}>Linear</MenuItem>
                            <MenuItem value={TrendMode.LOGISTIC}>Logistic</MenuItem>
                            <MenuItem value={TrendMode.FLAT}>Flat</MenuItem>
                        </Select>

                    </Stack>
                </MenuItem>

            )}

            {onInfluenceChange && (

                <MenuItem>

                    <Stack direction="row" spacing={4} justifyContent="space-between" alignItems="center" flex={1}>
                        <Typography variant="body2" color="text.secondary"> Influence </Typography>
                        <Slider defaultValue={defaultInfluence} onChange={handleSliderChange} aria-label="Default" valueLabelDisplay="auto" min={1} max={100} step={10}
                            valueLabelFormat={(value) => `${value}%`}
                        />
                    </Stack>

                </MenuItem>

            )}



        </Menu>
    );
};